import * as React from 'react';
import { ELayoutTypes } from '../../../../types/newbuilding/layouts';
import { RadioButtonsMultiple } from '../../../RadioButtonsMultiple/RadioButtonsMultiple';
import * as style from './LayoutTypeSwitcher.css';

interface ILayoutTypeSwitcherProps {
  initialLayoutType: ELayoutTypes;
  onClick(layoutType: ELayoutTypes): void;
}

export const LayoutTypeSwitcher: React.StatelessComponent<ILayoutTypeSwitcherProps> = props => {
  const { initialLayoutType, onClick } = props;

  return (
    <div className={style['controls']}>
      <RadioButtonsMultiple
        initialValue={initialLayoutType}
        options={[
          {
            value: ELayoutTypes.Layout,
            label: 'План квартиры',
          },
          {
            value: ELayoutTypes.Tour,
            label: '3D-планировка',
          },
        ]}
        name={'layoutType'}
        onClick={onClick}
      />
    </div>
  );
};
